<template>
  <div class="query-header">
    <el-row
      :gutter="20"
    >
      <el-col
        :lg="4"
        :md="6"
        :sm="24"
        :xs="24"
        class="el-col-el"
      >
        <el-input
          style="width: 100%;"
          v-model="keywords"
          placeholder="匹配关键字"
          clearable
        ></el-input>
      </el-col>
      <span
        style="display:inline-block;width: 10px"></span>
      <vs-button
        type="info"
        class="search-btn btn box-item"
        @click="searchHandle"
      >查询</vs-button>
      <span
        style="display:inline-block;width: 10px"></span>
      <vs-button
        v-if="isAuth('wx:msgreplyrule:save')"
        class="add-btn btn box-item"
        @click="addHandle"
      >新增</vs-button>
<!--      <vs-button
        v-if="isAuth('wx:msgreplyrule:delete')"
        :disabled="selected.length < 1"
        class="mutil-btn "
        @click="deleteHandle"
      >批量删除</vs-button>-->
    </el-row>
  </div>
</template>

<script>
import  { mapGetters } from 'vuex';
export default {
  name: "queryHeader",
  props: {
    selected: {
      type: Array,
      default(){
        return [];
      }
    },
  },
  data() {
    return {
      keywords: '',
    }
  },
  computed: {
    ...mapGetters(['userInfo','realMobile']),
  },
  created(){
  },
  methods: {
    toQuery(){
      this.$emit('toQuery');
    },
    searchHandle(){
      this.toQuery();
    },
    addHandle(){
      this.$emit('add');
    },
    deleteHandle(){
      this.$emit('delete');
    }
  },
}
</script>

<style lang="scss" scoped>
.query-header {
  .header-sub-item {
    width: 100%;
  }
  .box-item {
    margin-right: 10px;
  }
}
</style>
